// extracted by mini-css-extract-plugin
module.exports = {"reservationDetails":"Header_reservationDetails__2xzJT","backTitle":"Header_backTitle__1a0fv","center":"Header_center__1BUGf"};